import { loadingChunkRetry } from '@sit/client-shared';
import { Suspense, lazy } from 'react';
import { Helmet } from 'react-helmet';
import ErrorBoundary from '../../components/ErrorBoundary';
import PreviewComponent from './PreviewComponent';

const IntacctAdmin = lazy(() =>
  loadingChunkRetry(() => import('./IntacctAdmin')),
);

const IntacctAdminWrapper = () => {
  return (
    <ErrorBoundary>
      <Helmet>
        <title>Internal Admin Dashboard | Sage Intelligent Time</title>
      </Helmet>
      <Suspense fallback={<PreviewComponent />}>
        <IntacctAdmin />
      </Suspense>
    </ErrorBoundary>
  );
};

export default IntacctAdminWrapper;
